import {
  DeviceDetail,
  EventsDetail,
  EventsList,
  ImeiEvents,
  ImeiList,
  NotifyList,
  PabbitLiteDeviceLog,
  PabbitLiteEntranceLog,
  PabbitLiteList,
  ParcelLockerManagement,
  UnlockRecords,
} from "@admin/pages/devices-configure";
import { NavigateToResource } from "@refinedev/react-router-v6";
import type { RouteObject } from "react-router-dom";

const routes = [
  { index: true, element: <NavigateToResource resource="pabbit_lite" /> },
  { path: "pabbit_lite", element: <PabbitLiteList /> },
  { path: "pabbit_lite/log/:id", element: <PabbitLiteDeviceLog /> },
  { path: "pabbit_lite/entrance/:id", element: <PabbitLiteEntranceLog /> },
  { path: "locker/parcel_locker/:id", element: <ParcelLockerManagement /> },
  { path: "locker/unlock_records/:id", element: <UnlockRecords /> },
  { path: "notify", element: <NotifyList /> },
  { path: "imei", element: <ImeiList /> },
  { path: "imei/:imei/events", element: <ImeiEvents /> },
  { path: ":identity/events", element: <EventsList /> },
  { path: ":identity/events/:id", element: <EventsDetail /> },
  { path: ":property_id/:id", element: <DeviceDetail /> },
] satisfies RouteObject[];
export const devicesConfigureRoute = {
  path: "/devices-config",
  children: routes,
} satisfies RouteObject;
